import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { PlAudioComponent } from '@app/components/pl-audio/pl-audio.component';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';
import { MatSliderModule } from '@angular/material/slider';
import { PlSliderModule } from '@app/components/pl-slider/pl-slider.module';
import { FormsModule } from '@angular/forms';
import { SecondsToTimePipeModule } from '@shared/pipes/secondsToTime/secondsToTime.pipe.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatSliderModule,
    PlIconModule,
    PlSlicePipeModule,
    PlSliderModule,
    SecondsToTimePipeModule,
  ],
  declarations: [PlAudioComponent],
  exports: [PlAudioComponent],
})
export class PlAudioModule {}
